import React from "react";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import get from "lodash/get";
import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";
import { STATE_KEYS } from "utils/constants/state";
import classnames from "classnames";
import { STRIPE_EDUCATION } from "constants/education";
import { useFormikContext } from "formik";
import { useStripeFeature } from "utils/hooks/stripe";
import { STRIPE_FEATURES } from "utils/constants/stripe";
import { omitDeep } from "utils/data";

const AutoTaxToggle = () => {
  const { values, touched, setFieldTouched, setValues } = useFormikContext();
  const active = get(values, STATE_KEYS.SHORT_LINK.AUTOMATIC_TAX_ENABLED);
  const canEdit = !Boolean(values.id);
  const taxFeatureEnabled = useStripeFeature({ feature: STRIPE_FEATURES.TAX });
  const disabled = !taxFeatureEnabled || !canEdit;

  return (
    <div
      className={classnames("flex flex-row justify-between items-center", {
        pb3: active,
        mb3: !active
      })}
    >
      <div className="flex flex-column w-100">
        <div className="flex flex-row items-center justify-between">
          <label className="f5 fw6 db">
            {STRIPE_EDUCATION.AUTOMATIC_TAX.title}
          </label>
          <Toggle
            {...getToggleProps({
              active,
              disabled,
              setFieldValue: (_, updatedActive) => {
                if (
                  !get(touched, STATE_KEYS.SHORT_LINK.AUTOMATIC_TAX_ENABLED)
                ) {
                  setFieldTouched(
                    STATE_KEYS.SHORT_LINK.AUTOMATIC_TAX_ENABLED,
                    true
                  );
                }

                setTimeout(() => {
                  /**
                   * If updated value is true then remove tax_rates attribute
                   * Then set updated value on the automatic tax enabled path
                   */
                  const updatedValues = updatedActive
                    ? omitDeep(values, STATE_KEYS.SHORT_LINK.TAX_RATES)
                    : cloneDeep(values);

                  set(
                    updatedValues,
                    STATE_KEYS.SHORT_LINK.AUTOMATIC_TAX_ENABLED,
                    updatedActive
                  );
                  setValues(updatedValues);
                }, 0);
              }
            })}
          />
        </div>
        {taxFeatureEnabled && (
          <div className="f6 pt2 lh-copy">
            {STRIPE_EDUCATION.AUTOMATIC_TAX.checkout}
          </div>
        )}
      </div>
    </div>
  );
};

export default AutoTaxToggle;
